import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Client {
  id?: number;
  client_code: string;
  status?: string;
  client_name: string;
  direct_supervisor_name: string;
  website?: string;
  contact_email_primary: string;
  contact_first_name_primary: string;
  contact_last_name_primary: string;
  phone_primary: string;
  contact_email_secondary?: string;
  contact_first_name_secondary?: string;
  contact_last_name_secondary?: string;
  phone_secondary?: string;
  contract_start_date?: string;
  end_of_contract_date?: string;
  email_delivery_method?: string;
  timesheet_link?: string;
  timesheet_last_sent?: string;
  created_at?: string;
  updated_at?: string;
}

@Injectable({ providedIn: 'root' })
export class ClientService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getClients(page?: number, page_size?: number, filter?: any): Observable<Client[]> {
    let params = new HttpParams();
    if (page !== undefined) params = params.set('page', page);
    if (page_size !== undefined) params = params.set('page_size', page_size);
    if (filter) {
      Object.keys(filter).forEach(key => {
        if (filter[key]) {
          params = params.set(key, filter[key]);
        }
      });
    }
    return this.http.get<Client[]>(`${this.apiUrl}/api/clients`, { params });
  }


  getClient(id: number): Observable<Client> {
    return this.http.get<Client>(`${this.apiUrl}/api/clients/${id}`);
  }

  createClient(client: Client): Observable<Client> {
    return this.http.post<Client>(`${this.apiUrl}/api/clients`, client);
  }

  updateClient(id: number, client: Client): Observable<Client> {
    return this.http.put<Client>(`${this.apiUrl}/api/clients/${id}`, client);
  }

  deleteClient(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/clients/${id}`);
  }

  // Client Approvers
  getApprovers(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.apiUrl}/api/client-approvers`, { params: httpParams });
  }

  createApprover(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/client-approvers`, data);
  }

  updateApprover(id: number, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/client-approvers/${id}`, data);
  }

  deleteApprover(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/client-approvers/${id}`);
  }

  sendPortalLink(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/client-approvers/${id}/send-portal-link`, {});
  }
}
